import script from "./SalesOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesOffer.vue?vue&type=script&setup=true&lang=js"

import "./SalesOffer.vue?vue&type=style&index=0&id=293123e9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-293123e9"]])

export default __exports__